import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

import { StyledAlertContainer } from './alert-banner.styles';

interface AlertBannerProps {
  data: {
    formLabelHeader:
      | {
          en?: string;
          ar?: string;
        }
      | string;
  };
}

const AlertBanner: FC<AlertBannerProps> = ({ data }) => {
  const { formLabelHeader } = data;

  return (
    <StyledAlertContainer>
      <InfoOutlinedIcon />

      <Grid flexDirection="column">
        {typeof formLabelHeader === 'object' && formLabelHeader?.en && (
          <Typography variant="h6" sx={{ fontWeight: 500, textAlign: 'left' }}>
            {formLabelHeader?.en}
          </Typography>
        )}

        {typeof formLabelHeader === 'object' && formLabelHeader?.ar && (
          <Typography variant="h6" sx={{ fontWeight: 500, textAlign: 'right' }}>
            {formLabelHeader?.ar}
          </Typography>
        )}

        {typeof formLabelHeader === 'string' && (
          <Typography variant="h6" sx={{ fontWeight: 500, textAlign: 'left' }}>
            {formLabelHeader}
          </Typography>
        )}
      </Grid>
    </StyledAlertContainer>
  );
};

export default AlertBanner;
